// disables lazy loading for images above the fold
const imgLazyLoadingResolver = (container = document) => {
    const lazyImages = [].slice.call(container.querySelectorAll('img[loading="lazy"]'));
    const lazyImageObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const lazyImage = entry.target;
                lazyImage.setAttribute('loading', '');
                lazyImageObserver.unobserve(lazyImage);
            }
        });
    });
    lazyImages.forEach(lazyImage => {
        lazyImageObserver.observe(lazyImage);
    });
    window.addEventListener('load', () => {
        lazyImages.forEach(lazyImage => {
            lazyImageObserver.unobserve(lazyImage);
        });
    });
};
document.addEventListener('DOMContentLoaded', () => imgLazyLoadingResolver());

export { imgLazyLoadingResolver };
